// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InformesEncuestaPage_containerFilaBusqueda__ZJ\\+Y\\+ {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.InformesEncuestaPage_titulo__\\+OoTT {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
  margin-left: 10px;
}

.InformesEncuestaPage_divTodoEnUnaFila__4YAJq {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-left: 10px;
}

.InformesEncuestaPage_divCampos__PpWhW {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 0px;
}

.InformesEncuestaPage_divCamposItem__8323q {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  margin-top: 10px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.InformesEncuestaPage_atributo__x6D\\+u {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: wrap;
  text-align: left;
  color: var(--text-color-claro);
}

.InformesEncuestaPage_valor__q1oyd {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.InformesEncuestaPage_divBotonera__YX40u {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 5px;
}

.InformesEncuestaPage_circleImage__JO7gt {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 10px;
}
/* EncuestasPage.module.css */
.InformesEncuestaPage_containerGrillaUsuarios__QUTXL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

/* EncuestasPage.module.css */
.InformesEncuestaPage_containerGrillaUsuarios__QUTXL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.InformesEncuestaPage_containerUsuario__rxx8t {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

/* EncuestasPage.module.css */
.InformesEncuestaPage_containerGrillaUsuarios__QUTXL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.InformesEncuestaPage_containerUsuario__rxx8t {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 640px) {
  .InformesEncuestaPage_containerUsuario__rxx8t {
    flex: 1 1 45%;
    max-width: 45%;
  }
}
/* EncuestasPage.module.css */
.InformesEncuestaPage_containerGrillaUsuarios__QUTXL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px; /* Espacio entre los cuadros */
}

.InformesEncuestaPage_containerUsuario__rxx8t {
  flex: 1 1 100%;
  max-width: 100%;
  margin: 10px 0;
}

@media (min-width: 640px) {
  .InformesEncuestaPage_containerUsuario__rxx8t {
    flex: 1 1 45%;
    max-width: 45%;
  }
}

@media (min-width: 1024px) {
  .InformesEncuestaPage_containerUsuario__rxx8t {
    flex: 1 1 30%;
    max-width: 30%;
  }
}

.InformesEncuestaPage_containerUsuario__rxx8t {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin-top: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 640px) {
  .InformesEncuestaPage_containerFilaBusqueda__ZJ\\+Y\\+ {
    flex-wrap: nowrap;
  }

  .InformesEncuestaPage_containerUsuario__rxx8t {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 50%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 58%; /* Asegura que los botones no sean más anchos que el 30% */
  }

  .InformesEncuestaPage_divBotonera__YX40u {
    width: 70%;
    margin-left: 15px;
  }
}

@media (min-width: 1024px) {
  /* Ajusta este valor según tus necesidades */
  .InformesEncuestaPage_containerGrillaUsuarios__QUTXL {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .InformesEncuestaPage_containerUsuario__rxx8t {
    flex: 1 1 45%;
    max-width: 45%;
  }

  .InformesEncuestaPage_circleImage__JO7gt {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1200px) {
  .InformesEncuestaPage_containerUsuario__rxx8t {
    flex: 1 1 30%;
    max-width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/informes/informes-encuesta/InformesEncuestaPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,8BAA8B;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n  margin-left: 10px;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-left: 10px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 0px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  margin-top: 10px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: wrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n  margin-bottom: 10px;\n}\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 640px) {\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n}\n/* EncuestasPage.module.css */\n.containerGrillaUsuarios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px; /* Espacio entre los cuadros */\n}\n\n.containerUsuario {\n  flex: 1 1 100%;\n  max-width: 100%;\n  margin: 10px 0;\n}\n\n@media (min-width: 640px) {\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .containerUsuario {\n    flex: 1 1 30%;\n    max-width: 30%;\n  }\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin-top: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 640px) {\n  .containerFilaBusqueda {\n    flex-wrap: nowrap;\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 50%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 58%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n\n  .divBotonera {\n    width: 70%;\n    margin-left: 15px;\n  }\n}\n\n@media (min-width: 1024px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    flex: 1 1 45%;\n    max-width: 45%;\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1200px) {\n  .containerUsuario {\n    flex: 1 1 30%;\n    max-width: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerFilaBusqueda": `InformesEncuestaPage_containerFilaBusqueda__ZJ+Y+`,
	"titulo": `InformesEncuestaPage_titulo__+OoTT`,
	"divTodoEnUnaFila": `InformesEncuestaPage_divTodoEnUnaFila__4YAJq`,
	"divCampos": `InformesEncuestaPage_divCampos__PpWhW`,
	"divCamposItem": `InformesEncuestaPage_divCamposItem__8323q`,
	"atributo": `InformesEncuestaPage_atributo__x6D+u`,
	"valor": `InformesEncuestaPage_valor__q1oyd`,
	"divBotonera": `InformesEncuestaPage_divBotonera__YX40u`,
	"circleImage": `InformesEncuestaPage_circleImage__JO7gt`,
	"containerGrillaUsuarios": `InformesEncuestaPage_containerGrillaUsuarios__QUTXL`,
	"containerUsuario": `InformesEncuestaPage_containerUsuario__rxx8t`
};
export default ___CSS_LOADER_EXPORT___;
